import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Link } from 'react-router-dom';
import ButtonBase from '../../Buttons/ButtonBase';
import FormHeader from '../../../layouts/SignUpForm/FormHeader';

const useStyles = makeStyles(theme => ({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
      },
      TextField: {
        maxWidth: '336px',
        height: 74
      },
      colorActiveCheck: {
        color: '#094565',
        fontSize: 12,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: 0,
      paddingLeft: 0
      },
    colorActiveLabel: {
      '&:hover': {
        color: '#094565'
      },
      color: '#c1c1c1',
      fontSize: 12,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: 0,
      paddingLeft: 0
    },
    labelTermino: {
      fontWeight: '400'
    },
    FormControlLabelRoot: {
      margin: 0
    },
    checkPadding: {
      padding: '0',
      marginRight: 4,
    },
    linkTerms: {
      textDecoration: 'none',
      color: 'inherit'
    }
  }));

 
const InfoClient = (props) => {
    const {
        values:{email, password, termsAndConditions}
        ,handleChange,handleSubmit,
        touched,dirty,handleBlur,errors,isValid,
    } = props;
    const classes = useStyles();
    const [valuesPass, setValuesPass] = useState({
        showPassword: false,
      });

  
    const handleClickShowPassword = () => {
        setValuesPass({ ...valuesPass, showPassword: !valuesPass.showPassword });
      };

   

    return ( 
        <div style={{display:'flex',    
        flexDirection: 'column', width: '100%',
        alignItems: 'center'}}>

            <TextField
                label="Correo"
                type="email"
                id="email"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={email}
                helperText={touched.email && errors.email ? errors.email : ''}
                error={touched.email && errors.email ? true : false}
            />

            <TextField
                id="outlined-adornment-password"
                variant="outlined"
                type={valuesPass.showPassword ? 'text' : 'password'}
                label="Contraseña"
                name="password"
                classes={{ root: classes.TextField }}
                value={password}
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={
                touched.password && errors.password ? errors.password : ''
                }
                error={touched.password && errors.password ? true : false}
                InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                        aria-label="Toggle password visibility"
                        onClick={handleClickShowPassword}
                        classes={{
                        root: classes.colorGrayIcon
                        }}
                    >
                        {valuesPass.showPassword ? (
                        <VisibilityOff />
                        ) : (
                        <Visibility />
                        )}
                    </IconButton>
                    </InputAdornment>
                )
                }}
            />
            <div style={{width: 296}}>
        <FormControlLabel
          classes={{
            root: classes.FormControlLabelRoot
          }}
          control={
            <Checkbox
              name="termsAndConditions"
              id="termsAndConditions"
              checked={termsAndConditions}
              onChange={event => {
                handleChange(event);
                handleBlur(event);
              }}
              onBlur={handleBlur}
              value="checked"
              color="primary"
              label="Gilad Gray"
              classes={{
                root: classes.checkPadding
              }}
            />
          }
          label={
            <>
              <p className={termsAndConditions ? classes.colorActiveCheck: classes.colorActiveLabel}>
                <span className={classes.labelTermino}>Acepto los</span><a className={classes.linkTerms} href="/informacion-adicional" target="_blank"> Términos y condiciones</a> y la<a className={classes.linkTerms}  href="/informacion-adicional" target="_blank"> Política de Privacidad</a> de Contacta Abogado
              </p>
              {touched.termsAndConditions && errors.termsAndConditions && (
                <FormHelperText error>
                  {errors.termsAndConditions}
                </FormHelperText>
              )}
            </>
          }
        />
        </div>

            <div className="horizontal-layout" style={{ marginTop: 32 }}>
                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primary"
                    disabled={!isValid}
                    >
                    Continuar
                </ButtonBase>
            </div>
    </div>
     );
}
 
export default InfoClient;